let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("boIe9")]).then(() => parcelRequire('3aj3b'));